import {
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  fileFormsParams,
  FileFormsService,
  fileInputParams,
  HttpService,
  LocalStorageService,
  MessageService,
} from 'brainloper-ui';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { UpdateData } from 'src/app/models/commos/update-data';
import { ModalMaintenanceHistory } from 'src/app/models/maintenance/modal-maintenance-history';
import { HistoricalWO } from 'src/app/models/maintenance/historicalWO';

@Component({
    selector: 'app-modal-maintenance-history',
    templateUrl: './modal-maintenance-history.component.html',
    styleUrls: ['./modal-maintenance-history.component.scss'],
    standalone: false
})
export class ModalHistoryComponent implements OnInit {
  private urlPutOrdenHistorico: string = `${EndpointDictionary.historicalWO.CRUD_HISTORICAL_WO_DATA}`;
  public formPutOT: UntypedFormGroup;
  public companyId: number;
  private file = null;
  private file2 = null;
  private file3 = null;

  private paramsFile: fileFormsParams[]
  private paramsFile2: fileFormsParams[]
  private paramsFile3: fileFormsParams[]

  //imagen1
  public fileInput: fileInputParams

  //imagen2
  public fileInput2: fileInputParams

  //imagen3
  public fileInput3: fileInputParams

  constructor(
    public dialogRef: MatDialogRef<ModalHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalMaintenanceHistory<HistoricalWO>,
    private message: MessageService,
    private http: HttpService,
    private formBuilder: UntypedFormBuilder,
    private formFile: FileFormsService,
    private storage: LocalStorageService,
  ) {
    this.companyId = this.storage.get<number>('companyId');
    this.paramsFile = [
      {
        id: 'old',
        value: this.data.body.photo1,
      },
    ];

    this.paramsFile2 = [
      {
        id: 'old',
        value: this.data.body.photo2,
      },
    ];

    this.paramsFile3 = [
      {
        id: 'old',
        value: this.data.body.photo3,
      },
    ];

    this.fileInput = {
      typeFile: 'imagen',
      imageSrc:
        this.data.body.photo1 == '' || this.data.body.photo1 == 'undefined'
          ? ''
          : `${EndpointDictionary.Base._BASE_URL_V2}${this.data.body.photo1}/${this.companyId}`,
      input: 'vista',
      label: 'foto',
      edit: true,
      style: {
        width: '100%',
        height: screen.width > 400 ? '300px' : '150px',
        border: '1px solid black',
      },
    };

    //imagen2
    this.fileInput2 = {
      typeFile: 'imagen',
      imageSrc:
        this.data.body.photo2 == '' || this.data.body.photo2 == 'undefined'
          ? ''
          : `${EndpointDictionary.Base._BASE_URL_V2}${this.data.body.photo2}/${this.companyId}`,
      input: 'vista',
      label: 'foto',
      edit: true,
      style: {
        width: '100%',
        height: screen.width > 400 ? '300px' : '150px',
        border: '1px solid black',
      },
    };
    this.fileInput3 = {
      typeFile: 'imagen',
      imageSrc:
        this.data.body.photo3 == '' || this.data.body.photo3 == 'undefined'
          ? ''
          : `${EndpointDictionary.Base._BASE_URL_V2}${this.data.body.photo3}/${this.companyId}`,
      input: 'vista',
      label: 'foto',
      edit: true,
      style: {
        width: '100%',
        height: screen.width > 400 ? '300px' : '150px',
        border: '1px solid black',
      },
    };
    this.formPutOT = this.formBuilder.group({
      id: this.data.$event.id,
      workOrderId: this.data.$event.workOrderId,
      finalCost: 0,
      finalTime: 0,
      observations: '',
      photo1: '',
      photo2: '',
      photo3: '',
      odometer: 0,
      invoiceReference: '',
    });
  }

  ngOnInit(): void {
    //console.log(this.data)
    this.message.openLoading('Cargando', 'Cargando informacion');
    this.initFild();
  }

  initFild() {
    this.message.closeLoading();
    this.formPutOT.get('finalCost').setValue(this.data.body.finalCost);
    this.formPutOT.get('finalTime').setValue(this.data.body.finalTime);
    this.formPutOT.get('observations').setValue(this.data.body.observations);
    this.formPutOT.get('photo1').setValue(this.data.body.photo1);
    this.formPutOT.get('photo2').setValue(this.data.body.photo2);
    this.formPutOT.get('photo3').setValue(this.data.body.photo3);
    this.formPutOT.get('odometer').setValue(
      this.data.body.odometer
    );
    this.formPutOT.get('invoiceReference').setValue(
      this.data.body.invoiceReference
    );

  }

  async actualizarHistorico(form: HistoricalWO) {
    this.message.openLoading('Cargando', 'Actualizando Informacion');

    await this.uploadPhotoIfNotNull(form, this.file, 'photo1', this.paramsFile);
    await this.uploadPhotoIfNotNull(
      form,
      this.file2,
      'photo2',
      this.paramsFile2
    );
    await this.uploadPhotoIfNotNull(
      form,
      this.file3,
      'photo3',
      this.paramsFile3
    );


    const res: GenericResponse = await this.http.putDataBody(
      this.urlPutOrdenHistorico,
      form
    );

    if (res) {
      this.message.closeLoading();
      this.dialogRef.close();
      this.message.SuccessToast(
        'Historico Orden de Trabajo actualizado correctamente'
      );
    } else {
      this.message.closeLoading();
    }
  }

  async uploadPhotoIfNotNull(
    form: HistoricalWO,
    file: File,
    photoField: string,
    paramsFile: any
  ) {
    if (!file) {
      console.log(`No se agregó foto en ${photoField}`);
      form[photoField] = this.data.body[photoField];
      return;
    }

    const formFoto = this.formFile.createMultipartForm(file, paramsFile);
    const res: string = await this.http.postDataBody(
      EndpointDictionary.Docs.DOCS_SUBIR,
      formFoto
    );

    if (res) {
      form[photoField] = res;
    }
  }

  errorMessage() {
    this.message.Error('Error', 'complete los campos');
  }

  fileSave($event: UpdateData<File>, i: number) {
    switch (i) {
      case 1:
        if ($event.compressor) {
          this.file = $event.compressor;
        } else {
          this.file = $event.new;
        }
        break;

      case 2:
        if ($event.compressor) {
          this.file2 = $event.compressor;
        } else {
          this.file2 = $event.new;
        }
        break;

      case 3:
        if ($event.compressor) {
          this.file3 = $event.compressor;
        } else {
          this.file3 = $event.new;
        }
        break;

      default:
        break;
    }
  }
}
